import React, { useState, useEffect } from 'react';
import { FormControl, Select, MenuItem } from '@mui/material';
import { colors } from '../../../theme/color-palette';
import { useStyles, selectStyleMenu } from '../styles';
import { changePersona } from '../../../redux/actions/appGuideActions';
import { useDispatch } from 'react-redux';
import {
	BOGLE_REGULAR,
	CATMANVIEW,
	STANDARDVIEW,
	MAIN_INSIGHTS_DASHBOARD
} from '../../../constants/constant';
import PropTypes from 'prop-types';
import { resetFullCompanyViewReducer } from '../../../redux/actions/fullCompanyViewAction';
import { saveEventTrack } from '../../../redux/actions/eventTrackAction';
import { UserPortalContext } from '../../../context/appcontext';
import analytics from '../../../helper/analytics';
import tracker from '../../../constants/tracker';

const CatmanView = ({ isItemDrilldown }) => {
	const classes = useStyles();
	const [openMenu, setOpenMenu] = useState(false);
	const [selectedPersona, setSelectedPersona] = useState(CATMANVIEW);

	const dispatch = useDispatch();
	const portalUserContext = React.useContext(UserPortalContext);

	const { PURPLE } = colors;

	useEffect(() => {
		if (!isItemDrilldown) {
			const dashboardView = localStorage.getItem('dashboardView');
			if (dashboardView) {
				sessionStorage.setItem('view', dashboardView);
				setSelectedPersona(dashboardView);
				dispatch(changePersona(dashboardView));
			} else {
				sessionStorage.setItem('view', CATMANVIEW);
				localStorage.setItem('dashboardView', CATMANVIEW);
				dispatch(changePersona(CATMANVIEW));
			}
		} else {
			const dashboardView = localStorage.getItem('dashboardView');
			sessionStorage.setItem('view', dashboardView);
			setSelectedPersona(dashboardView);
			dispatch(changePersona(dashboardView));
		}
	}, []);

	const onParsonaChange = (e) => {
		const view = e?.target?.value === CATMANVIEW ? CATMANVIEW : STANDARDVIEW;
		const request = {
			event: 'SWITCH_PERSONA',
			event_description: `Switches from ${selectedPersona} to ${view}`,
			attributes: MAIN_INSIGHTS_DASHBOARD,
		};
		analytics.trackEventInfo({
			type: tracker.EVENTS.CLICK,
			actionOn: `User Switches from ${selectedPersona} to ${view}`,
		});
		setSelectedPersona(view);
		dispatch(changePersona(view));
		dispatch(resetFullCompanyViewReducer());
		dispatch(saveEventTrack({ request, portalUserContext }));
		localStorage.setItem('dashboardView', view);
		sessionStorage.setItem('view', view);
	};

	return (
		<FormControl className={classes.formControlCatman} size="small">
			<Select
				data-test-id="persona-dropdown"
				id="persona-dropdown"
				value={selectedPersona}
				onChange={onParsonaChange}
				onOpen={() => setOpenMenu(true)}
				onClose={() => setOpenMenu(false)}
				className={openMenu ? classes.onFocus : ''}
				sx={{
					borderRadius: '20px !important',
					height: '32px !important',
					fontFamily: BOGLE_REGULAR,
					fontSize: 14,
					'& .MuiSelect-select': {
						fontFamily: BOGLE_REGULAR,
						display: 'flex !important',
						alignItems: 'center !important',
					},
					'& .MuiSvgIcon-root': {
						color: `${PURPLE} !important`,
					},
				}}
				MenuProps={{
					sx: selectStyleMenu,
					disablePortal: true,
				}}>
				<MenuItem
					data-test-id="CATMAN"
					value={CATMANVIEW}
					sx={{
						fontSize: '14px !important',
						fontFamily: `${BOGLE_REGULAR} !important`,
						display: 'flex !important',
						lineHeight: '2 !important',
					}}>
					{CATMANVIEW}
				</MenuItem>
				<MenuItem
					data-test-id="SUPPLIER"
					value={STANDARDVIEW}
					sx={{
						fontSize: '14px !important',
						fontFamily: `${BOGLE_REGULAR} !important`,
						display: 'flex !important',
						lineHeight: '2 !important',
					}}>
					{STANDARDVIEW}
				</MenuItem>
			</Select>
		</FormControl>
	);
};

CatmanView.propTypes = {
	isItemDrilldown: PropTypes.bool,
};

export default CatmanView;
